import { FETCH_EVENTS, FETCH_EVENTS_SUCCESS, FETCH_EVENTS_FAILURE } from '../actions';

const initialState = {
  events: [],
  loading: true,
  err: null,
  haveData: false
};

export const reducer = (state = initialState, action) => {
  switch(action.type) {
    case FETCH_EVENTS:
      return {
        ...state,
        loading: true,
        err: null,
        haveData: false
      };
    case FETCH_EVENTS_SUCCESS:
      return {
        ...state,
        loading: false,   
        haveData: true,     
        events: action.data
      };
    case FETCH_EVENTS_FAILURE:
      return {
        ...state,
        loading: false,
        haveData: false,
        err: action.error,
        events: []
      };
    default:
      return state;
  }
}